import Styles from './styles.module.css';
import React from 'react'
import { useAppSelector } from 'src/salon/app/hook';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import Service from './../../../../image/login/service.png';
import { useNavigate } from 'react-router-dom';

const ManualComplete: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);
  const navigate = useNavigate();

  const update = async () => {
    if (!company?.id) return;

    try {
      const ref = doc(getFirestore(), "companies", company.id);

      await updateDoc(ref, {
        "progress.complete": true,
      });

      navigate("/service/setting", { replace: true });

    } catch (error) {
      console.error("update failed:", error);
    }
  };

  return (
    <div className={Styles.plan}>
      <div className={Styles.inner}>

        <p className={Styles.kicker}>STEP 5</p>
        <h1 className={Styles.title}>初期設定はこれで完了です</h1>
        <p className={Styles.lead}>
          作成お疲れさまでした。有料プランの方は、続けて求人作成にお進みください。
        </p>

        <button type='button' className={Styles.primary} onClick={() => update()}>
          理解した
        </button>

        <section className={Styles.card}>
          <p className={Styles.cardText}>
            事業者様・学校・学生の連携の仕組みを図解しています。ぜひご覧ください。
          </p>
          <img className={Styles.diagram} src={Service} alt='事業者・学校・学生の連携図' />
        </section>

      </div>
    </div>
  );
}

export default ManualComplete;
